import { call, put } from "redux-saga/effects";
import { api } from "../../../services";
import { Creators } from "./index";

import { Alerts } from "../../../lib";

export default function* newUserAssociated({ data, callback }) {
  try {
    yield call(api.newUserAssociated, data);

    yield put(Creators.newUserAssociatedSuccess());

    callback();
  } catch (response) {
    Alerts.alertError(
      response?.data?.log
        ? response?.data?.log
        : "Erro ao cadastrar novo usuário",
      1
    );

    yield put(Creators.newUserAssociatedFailure());
  }
}
